module.exports = __webpack_public_path__ + "img/bg-07.6ad5f343.png";